  <iris-card class="skeleton-loader provider-listing-container">
    <div class="skeleton-box box-1"></div>
    <div class="skeleton-box box-2"></div>
    <div class="skeleton-box box-3"></div>
    <div class="skeleton-box box-4"></div>
    <div class="skeleton-box box-5"></div>
  </iris-card>
